import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
const FIELD_KEY = "irie_field_session";
export const getFieldSession = () => {
  try {
    const s = JSON.parse(localStorage.getItem(FIELD_KEY) || "null");
    return s && new Date(s.expires_at) > new Date() ? s : null;
  } catch (e) { return null; }
};
export const setFieldSession = (s) => (s ? localStorage.setItem(FIELD_KEY, JSON.stringify(s)) : localStorage.removeItem(FIELD_KEY));
api.interceptors.request.use((cfg) => {
  const s = getFieldSession();
  if (s) cfg.headers.Authorization = `Bearer ${s.token}`;
  return cfg;
});
export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const getAssets = () => api.get("/assets").then((r) => r.data);
export const getStatus = () => api.get("/ingest/status").then((r) => r.data);
export const startIngest = () => api.post("/ingest").then((r) => r.data);
export const exportUrl = (scenario, intensity, slr) =>
  `${API}/export.csv?scenario=${scenario}&intensity=${intensity}&sea_level_rise=${slr}`;

// --- Live Simulation Engine ---
export const getBuildStatus = () => api.get("/build/status").then((r) => r.data);
export const startBuild = () => api.post("/build").then((r) => r.data);
export const getGullies = () => api.get("/gullies").then((r) => r.data);
export const getInundation = (scenario, intensity, slr, hour, drill) =>
  api.get("/inundation", { params: { scenario, intensity, sea_level_rise: slr, hour, drill: drill || undefined } }).then((r) => r.data);
export const getCascade = (scenario, intensity, slr, hour, drill) =>
  api.get("/cascade", { params: { scenario, intensity, sea_level_rise: slr, hour, drill: drill || undefined } }).then((r) => r.data);
export const getRunoff = (hour, drill) =>
  api.get("/runoff", { params: { hour, drill: drill || undefined } }).then((r) => r.data);
export const getTelemetryLive = () => api.get("/telemetry/live").then((r) => r.data);
export const getTelemetryLatest = () => api.get("/telemetry/latest").then((r) => r.data);
export const getAlerts = () => api.get("/alerts").then((r) => r.data);
export const clearAlerts = () => api.post("/alerts/clear", {}, { headers: { "X-Admin-Token": getAdminSession()?.token || "" } }).then((r) => r.data);
export const getForecast = (drill) =>
  api.get("/forecast", { params: drill ? { drill } : {} }).then((r) => r.data);
export const getHurricanes = () => api.get("/hurricanes").then((r) => r.data);
export const getParishes = () => api.get("/parishes").then((r) => r.data);
export const buildParishes = () => api.post("/parishes/build").then((r) => r.data);
export const downloadBriefing = async (params) => {
  const r = await api.get("/briefing.pdf", { params: { ...params, drill: params.drill || undefined }, responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || "briefing.pdf";
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
export const fieldLogin = (code, name) => api.post("/field/login", { code, name }).then((r) => r.data);
export const getClosures = () => api.get("/closures").then((r) => r.data);
export const createClosure = (asset_id, reason, note) => api.post("/closures", { asset_id, reason, note }).then((r) => r.data);
export const reopenClosure = (id) => api.post(`/closures/${id}/reopen`).then((r) => r.data);
export const getShelters = (params) =>
  api.get("/shelters", { params: { ...params, drill: params.drill || undefined } }).then((r) => r.data);
export const updateShelter = (id, body) => api.put(`/shelters/${id}`, body).then((r) => r.data);

const ADMIN_KEY = "irie_admin_session";
export const getAdminSession = () => {
  try {
    const s = JSON.parse(localStorage.getItem(ADMIN_KEY) || "null");
    return s && new Date(s.expires_at) > new Date() ? s : null;
  } catch (e) { return null; }
};
export const setAdminSession = (s) => (s ? localStorage.setItem(ADMIN_KEY, JSON.stringify(s)) : localStorage.removeItem(ADMIN_KEY));
const adm = () => ({ headers: { "X-Admin-Token": getAdminSession()?.token || "" } });
export const adminLogin = (email, password) => api.post("/admin/login", { email, password }).then((r) => r.data);
export const listSlack = () => api.get("/admin/slack", adm()).then((r) => r.data);
export const addSlack = (label, url) => api.post("/admin/slack", { label, url }, adm()).then((r) => r.data);
export const toggleSlack = (id, enabled) => api.patch(`/admin/slack/${id}`, { enabled }, adm()).then((r) => r.data);
export const deleteSlack = (id) => api.delete(`/admin/slack/${id}`, adm()).then((r) => r.data);
export const testSlack = (id) => api.post(`/admin/slack/${id}/test`, {}, adm()).then((r) => r.data);
export const getSatEvents = () => api.get("/satellite/events").then((r) => r.data);
export const analyseSat = (id) => api.post(`/satellite/${id}/analyse`).then((r) => r.data);
export const getSat = (id) => api.get(`/satellite/${id}`).then((r) => r.data);
export const getPhotos = (id) => api.get(`/satellite/${id}/photos`).then((r) => r.data);
export const startPhotos = (id) => api.post(`/satellite/${id}/photos`).then((r) => r.data);
export const sendMorningBrief = () => api.post("/admin/morning-brief/send", {}, adm()).then((r) => r.data);
export const lastMorningBrief = () => api.get("/admin/morning-brief/last", adm()).then((r) => r.data);
